import React, { useEffect, useRef } from 'react';
import flatpickr from 'flatpickr';
import { MandarinTraditional } from 'flatpickr/dist/l10n/zh-tw';
import 'flatpickr/dist/flatpickr.min.css';

// Same library/version and date-only options as GeoManageWeb's log pages.
export default function LogDatePicker({ id, value, onChange }) {
    const input = useRef(null);
    const picker = useRef(null);
    const callback = useRef(onChange);
    callback.current = onChange;
    useEffect(() => {
        picker.current = flatpickr(input.current, {
            dateFormat: 'Y-m-d', locale: MandarinTraditional,
            allowInput: true, disableMobile: true,
            onChange: (_, text) => callback.current(text)
        });
        return () => { picker.current.destroy(); picker.current = null; };
    }, []);
    useEffect(() => {
        // Do not reparse/erase a partially typed date on every React render.
        if (input.current.value !== (value || '')) picker.current?.setDate(value || null, false, 'Y-m-d');
    }, [value]);
    return <input id={id} ref={input} type="text" className="form-control" placeholder="YYYY-MM-DD"
        autoComplete="off" onChange={event => callback.current(event.target.value)} />;
}
